var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrigger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86036 6.15935V3.66602C5.86036 2.74602 6.60703 1.99935 7.52703 1.99935C8.44703 1.99935 9.1937 2.74602 9.1937 3.66602V6.15935C10.0004 5.61935 10.527 4.70602 10.527 3.66602C10.527 2.00602 9.18703 0.666016 7.52703 0.666016C5.86703 0.666016 4.52703 2.00602 4.52703 3.66602C4.52703 4.70602 5.0537 5.61935 5.86036 6.15935ZM9.52703 7.80602C9.34036 7.71268 9.14036 7.66602 8.9337 7.66602H8.52703V3.66602C8.52703 3.11268 8.08036 2.66602 7.52703 2.66602C6.9737 2.66602 6.52703 3.11268 6.52703 3.66602V10.826L4.2337 10.346C3.98703 10.2927 3.72703 10.3727 3.54703 10.5527C3.26036 10.846 3.26036 11.3127 3.54703 11.606L6.22036 14.2793C6.4737 14.526 6.8137 14.666 7.16703 14.666H11.2337C11.9004 14.666 12.4604 14.1793 12.5537 13.5194L12.9737 10.5393C13.0537 9.97268 12.7604 9.41268 12.247 9.15935L9.52703 7.80602Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrigger);
export default __webpack_public_path__ + "static/media/Trigger.6ab81960589d2f15114a855b6ceec8d9.svg";
export { ForwardRef as ReactComponent };